var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Stack } from "@mui/material";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import RegistrationsPanel from "./RegistrationsPanel";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
var CustomerPortalRegistrationManagement = function () {
    var location = useLocation();
    var _a = useState(null), selctedPortal = _a[0], setSelectedPortal = _a[1];
    var _b = useState([]), brands = _b[0], setBrands = _b[1];
    var fetchBrands = function (cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, brandsData, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: true,
                            cancelToken: cancelToken,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        brandsData = response.data.data || [];
                        setBrands(brandsData);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch brands", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _d.sent();
                    if (axios.isCancel(error_1))
                        return [2];
                    utility.alert(((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || "Failed to fetch brands", constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        var cancelled = false;
        var source = axios.CancelToken.source();
        var loadBrands = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!cancelled) return [3, 2];
                        return [4, fetchBrands(source.token)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        loadBrands();
        return function () {
            cancelled = true;
            source.cancel("Component unmounted");
        };
    }, [location.key]);
    return (React.createElement(Stack, { sx: { p: 3, minHeight: "calc(100dvh - 200px)", gap: 2 } },
        React.createElement(CommonHeader, { mainTitle: "Admin Registration", subTitle: "Manage the complete customer Admin Registration invitation process, including sending and resending invites.", icon: React.createElement(HowToRegOutlinedIcon, { sx: { svg: { height: 24, width: 24 }, height: 24 } }) }),
        React.createElement(RegistrationsPanel, { portalId: selctedPortal, brands: brands, selectedPortal: selctedPortal, onPortalChange: setSelectedPortal })));
};
export default CustomerPortalRegistrationManagement;
